
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/taxes",
      function () {
        return require("private-next-pages/terms/taxes/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/taxes"])
      });
    }
  